import {Component, Input} from '@angular/core';
import {ScheduleService} from '../../services/schedule.service';
import {Schedule} from '../../models/Schedule';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-bandwidth-summary',
  templateUrl: './bandwidth-summary.component.html',
  styleUrls: ['./bandwidth-summary.component.scss']
})
export class BandwidthSummaryComponent {
  @Input()
  currentUser: UserLogged;
  schedules: Schedule[];

  constructor(private scheduleService: ScheduleService) {
  }

  @Input()
  set selected(selected: boolean) {
    if (selected) {
      this.getSchedules();
    }
  }

  getSchedules() {
    this.scheduleService.getSchedules().subscribe(
      schedules => {
        this.schedules = schedules;
      }
    );
  }
}
